import { FC } from 'react'

import { BitazzaText } from '../../../../components'
import Styles from './Tiers.module.scss'

interface Props {
    benefits?: string
    description?: string
    id?: number
    image?: string
    name?: string
}
export const NftDetail: FC<Props> = ({
    benefits,
    description,
    id,
    image,
    name,
}) => {
    return (
        <div className={Styles.nftDetailContainer}>
            <div className={Styles.nameNftContainer}>
                <img src={image} alt="rewards" width={80} />
                <BitazzaText
                    content={name}
                    color="#FFFFFF"
                    format="t20"
                    bold
                    letterSpacing={2}
                    textAlign="center"
                />{' '}
            </div>

            <div className={Styles.descNftContainer}>
                {' '}
                <BitazzaText
                    content={description}
                    color="#86A1A1"
                    format="t16"
                    textAlign="center"
                />
                <BitazzaText content={benefits} color="#86A1A1" format="t16" />
            </div>
        </div>
    )
}
